import React, { PureComponent, PropTypes } from 'react';
import Collapsible from 'react-collapsible';

import './accordion.scss';

class Accordion extends PureComponent {

  constructor(props) {
    super(props);
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.state = {
      openPosition: this.props.startPosition || 0,
    };
  }

  handleTriggerClick(position) {
    this.setState({
      openPosition: position
    });
  }

  render() {
    const nodes = this.props.children.map((node, index) => {
      const triggerWhenOpen = (node.props['data-trigger-when-open']) ? node.props['data-trigger-when-open'] : node.props['data-trigger'];
      const triggerDisabled = (node.props['data-trigger-disabled']) || false;
      return (
        <Collapsible
          key={`Collapsible${index}`}
          handleTriggerClick={this.handleTriggerClick}
          open={(this.state.openPosition === index)}
          trigger={node.props['data-trigger']}
          triggerWhenOpen={triggerWhenOpen}
          triggerDisabled={triggerDisabled}
          transitionTime={this.props.transitionTime}
          easing={this.props.easing}
          classParentString={this.props.classParentString}
          accordionPosition={index}
        >{node}</Collapsible>
      );
    });

    return (
      <div className="mt-accordion-wrapper">
        <div>
          {nodes}
        </div>
      </div>
    );
  }
}

Accordion.propTypes = {
  transitionTime: PropTypes.number,
  easing: PropTypes.string,
  startPosition: PropTypes.number,
  classParentString: PropTypes.string,
  children: PropTypes.arrayOf(React.PropTypes.shape({
    props: PropTypes.shape({
      'data-trigger': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
      ]).isRequired,
      'data-triggerWhenOpen': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
      ]),
      'data-triggerDisabled': PropTypes.bool,
    })
  }))
};

export default Accordion;



/** WEBPACK FOOTER **
 ** ./core_components/Accordion/index.js
 **/